<template>
  <div class="bespread-wrap module-layer5">
    <div class="screen-container">
      <div class="layer-cnt">
        <div class="h-btn">
          <div
            v-for="(item, idx) in [1, 2]"
            :key="idx"
            class="btn-icon cursor"
            @click="handleBtn(item)"
          >
            <img
              v-if="btnIdx == item"
              :src="
                require('../../assets/img/layer5/' +
                  lang +
                  '/btn-' +
                  item +
                  '-active.png')
              "
            />
            <img
              v-else
              :src="
                require('../../assets/img/layer5/' +
                  lang +
                  '/btn-' +
                  item +
                  '.png')
              "
            />
          </div>
        </div>
        <div class="r-cnt"  v-for="(sItem, idx) in list" :key="idx" v-if="btnIdx == sItem.id">
          <swiper :options="featuresOptions" ref="featuresSwiper">
            <swiper-slide v-for="(iconItem, idx) in sItem.bannerNum" :key="idx">
              <div class="img-size">
                <img
                  :src="
                    require('../../assets/img/layer5/' +
                      lang +
                      '/btn' +
                      btnIdx +
                      '/' +
                      iconItem +
                      '.jpg')
                  "
                  alt=""
                  srcset=""
                />
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev-role"></div>
          <div class="swiper-button-next-role"></div>
          <div class="swiper-pagination-media"></div>
        </div>
        <div class="f-copyright">
          <img
            src="../../assets/img/layer5/copyright.png"
            alt=""
            srcset=""
            class="copyright"
          />
          <div class="link-txt">
            <a href="https://privacy.ujoygames.com/" target="_blank">PRIVACY POLICY</a>
            <span>|</span>
            <a href="https://useragreement.ujoygames.com/" target="_blank">USER AGREEMENT</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      lang: "en",
      btnIdx: 1,
      featuresOptions: {
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper

        allowTouchMove: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 10,
          depth: 160,
          modifier: 2,
          slideShadows: true
        },
        pagination: {
          el: ".swiper-pagination-media",
          clickable: true,
          bulletClass: "custom-bullet",
          bulletActiveClass: "custom-bullet-active"
        },
        navigation: {
          nextEl: ".swiper-button-next-role",
          prevEl: ".swiper-button-prev-role"
        }
      },
      list: [
        {
          id: 1,
          bannerNum: 6
        },
        {
          id: 2,
          bannerNum: 12
        }
      ]
    };
  },
  watch: {},
  methods: {
    handleBtn(item) {
      this.btnIdx = item;
    
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer5 {
  // pointer-events: none;
  // top: 0;

  .screen-container {
    background-image: url("../../assets/img/layer5/bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .layer-cnt {
      .h-btn {
        display: flex;
        align-items: center;
        position: absolute;
        top:7vw;
        left: 50%;
        transform: translate(-50%, 0);
      }
      .btn-icon {
        width: 221px;
        height: 59px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .r-cnt {
        width: 1125px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 11vw;
        .swiper-slide {
          width: 80%;
          height: 100%;

          .img-size {
            width: 900px;
            height: 516px;
            background-image: url("../../assets/img/layer5/gd-hbimg.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: relative;

            img {
              // width: calc(100% - 60px);
              width: 95%;
              height: auto;
              // height: calc(100% - 32px);
              display: block;
              position: absolute;
              top: 0.8vw;
              left: 1.5vw;
              // left: 50%;
              // width: 100%;
              // height: 100%;
            }
          }
        }

        .swiper-button-prev-role:after,
        .swiper-button-next-role:after {
          display: none;
        }

        .swiper-button-prev-role {
          background: url("../../assets/img/layer5/prev.png") no-repeat top;
          background-size: 100% 100%;
          width: 48px;
          height: 58px;
          top: 50%;
          left: -96px;
          position: absolute;
          z-index: 1;
        }

        .swiper-button-next-role {
          background: url("../../assets/img/layer5/next.png") no-repeat top;
          background-size: 100% 100%;
          width: 48px;
          height: 58px;
          right: -96px;
          top: 50%;
          position: absolute;
          z-index: 1;
        }
        /deep/ .swiper-pagination-media {
          position: absolute;
          bottom: -3.5vw;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 36px;
          left: 50%;
          transform: translateX(-50%);
          cursor: pointer;
          .custom-bullet {
            display: inline-block;
            width:19px;
            height: 19px;
            background-color: #ffffff;
            background: url("../../assets/img/layer5/media.png") no-repeat top;
            background-size: 100% 100%;
          }

          .custom-bullet-active {
            width: 35px;
            height: 35px;
            background: url("../../assets/img/layer5/media-active.png")
              no-repeat top;
            background-size: 100% 100%;
          }
        }
      }
      .f-copyright {
        background: #000;
        width: 100%;
        height: 86px;
        position: fixed;
        bottom: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        gap: 0.3vw;
        .copyright {
          width: 583px;
          height: 33px;
          display: block;
        }
        .link-txt {
          font-family: AppleSDGothicNeoL00;
          font-size: 16px;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer5.vue